import { useRoutes } from "react-router-dom";
import {
  ERROR,
  TIMEOUT,
  CUSTOMER_RESULT,
  //利用者登録/変更
  IS_NEW_CUSTOMER_HANDLER,
  CUSTOMER_CREATOR,
  CUSTOMER_PRE_INFO,
  CUSTOMER_UPDATER,
  FAMILY_ADDER,
  //処方箋申込
  CUSTOMER_SELECTOR,
  PHARMACY_LIST,
  PHARMACY_SELECTOR,
  PHARMACY_INFORMATION,
  INTERVIEW_NOT_REGISTERED,
  IS_NEW_PHARMACY_SELECTOR,
  PRESCRIPTION_TYPE_SELECTOR,
  SPECIFIED_COMMERCIAL,
  PRESCRIPTION_DIRECTOR,
  PRESCRIPTION_RESERVATION,
  RECEPTION_METHOD,
  INSURANCE_INFORMATION,
  PRESCRIPTION_CREATOR,
  FINISHED_PRESCRIPTION,
  MY_PAGE,
  //問診
  MEDICAL_QUESTIONNAIRES_CUSTOMER_SELECTOR,
  MEDICAL_QUESTIONNAIRES,
  //お会計
  MEDICAL_ACCOUNT,
  PAYING_PAGE,
  //ご利用履歴
  PRESCRIPTION_HISTORY,
  //クレジットカード決済
  SELECT_CREDIT_CARD,
  //PAY決済開始
  START_PAY,
  //GMO I/F呼出
  NAVIGATE_PAY,
  //PAY決済確認中
  CONFIRMING_PAY,
  //受取薬履歴
  MEDICAL_HISTORY,
  RECEIVE_MEDICATION_DETAILS,
  // skywayオンライン面談
  PRESCRIPTION_MEDICATION_GUIDANCE,
  // 物品譲渡用決済方法選択画面
  PRODUCT_DELIVERY_SELECT_PAYMENT_METHOD,
  // 物品譲渡用決済画面
  PRODUCT_DELIVERY_SELECT_CREDIT_CARD,
  // 物品譲渡用決済完了画面
  PRODUCT_DELIVERY_COMPLETE_PAYMENT,
  // 物品譲渡エラー画面
  PRODUCT_DELIVERY_ERROR,
  // 物品譲渡Pay決済開始画面
  PRODUCT_DELIVERY_START_PAY,
  // 物品譲渡PAY決済確認中画面
  PRODUCT_DELIVERY_CONFIRMING_PAY,
} from "./path";
import { Error, NotFound, Timeout } from "../views/common";
import Result from "../views/common/result";
//利用者登録/変更
import IsNewCustomerHandler from "../views/customerCreator";
import CustomerCreator from "../views/customerCreator/creator/customerCreator";
import CustomerPreInfo from "../views/customerCreator/creator/customerPreInfo";
import CustomerUpdater from "../views/customerCreator/updater/customerUpdater";
import FamilyAdder from "../views/common/familyAdder";
// 処方箋受付申込
import CustomerSelector from "../views/prescriptionCreator/customerSelector";
import PharmacyList from "../views/prescriptionCreator/pharmacyList";
import PharmacySelector from "../views/prescriptionCreator/pharmacySelector";
import PharmacyInformation from "../views/prescriptionCreator/pharmacyInformation";
import IsNewPharmacySelectorHandler from "../views/prescriptionCreator";
import PrescriptionTypeSelector from "../views/prescriptionCreator/prescriptionTypeSelector";
import PrescriptionDirector from "../views/prescriptionCreator/prescriptionDirector";
import PrescriptionReservation from "../views/prescriptionCreator/prescriptionReservation";
import ReceptionMethod from "../views/prescriptionCreator/receptionMethod";
import InsuranceInformation from "../views/prescriptionCreator/insuranceInformation";
import PrescriptionCreator from "../views/prescriptionCreator/prescriptionCreator";
import FinishedPrescription from "../views/prescriptionCreator/finishedPrescription";
import InterviewNotRegistered from "../views/prescriptionCreator/interviewNotRegistered";
import MyPage from "../views/myPage";
//問診
import MedicalQuestionnairesCustomerSelector from "../views/medicalQuestionnaire/customerSelector";
import MedicalQuestionnaires from "../views/medicalQuestionnaire/medicalQuestionnaires";
//お会計
import MedicalAccount from "../views/medicalAccount";
import PayingPage from "../views/medicalAccount/payingPage";
// PAY決済開始
import StartPay from "../views/medicalAccount/startPay";
// GMO I/F呼出
import NavigatePay from "../views/medicalAccount/navigatePay";
// PAY決済確認中
import ConfirmingPay from "../views/medicalAccount/confirmingPay";
//ご利用履歴
import PrescriptionHistory from "../views/prescriptionHistory";
import SpecifiedCommercial from "../views/prescriptionCreator/specifiedCommercial";
//クレジットカード決済
import SelectCreditCard from "../views/medicalAccount/selectCreditCard";
//受取薬履歴
import MedicalHistory from "../views/medicalHistory";
//受取薬明細
import ReceiveMedicationDetails from "../views/medicalHistory/receiveMedicationDetails";
// skywayオンライン面談
import PrescriptionMedicationGuidance from "../views/prescriptionMedicationGuidance";
// 物品譲渡用決済方法選択画面
import ProductDeliverySelectPaymentMethod from "../views/productDelivery/selectPaymentMethod";
// 物品譲渡用決済画面
import ProductDeliverySelectCreditCard from "../views/productDelivery/selectCreditCard";
// 物品譲渡用決済完了画面
import ProductDeliveryCompletePayment from "../views/productDelivery/completePayment";
// 物品譲渡エラー画面
import ProductDeliveryError from "../views/productDelivery/error";
// 物品譲渡Pay決済開始画面
import ProductDeliveryStartPay from "../views/productDelivery/startPay";
// 物品譲渡PAY決済確認中画面
import ProductDeliveryConfirmingPay from "../views/productDelivery/confirmingPay";

const Routes = [
  {
    path: "/",
    element: <IsNewCustomerHandler />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: ERROR,
    element: <Error />,
  },
  {
    path: TIMEOUT,
    element: <Timeout />,
  },
  {
    path: MY_PAGE,
    element: <MyPage />,
  },
  {
    path: CUSTOMER_CREATOR,
    element: <CustomerCreator />,
  },
  { path: CUSTOMER_RESULT, element: <Result /> },
  //利用者登録/変更
  {
    path: IS_NEW_CUSTOMER_HANDLER,
    element: <IsNewCustomerHandler />,
  },
  {
    path: CUSTOMER_CREATOR,
    element: <CustomerCreator />,
  },
  {
    path: CUSTOMER_PRE_INFO,
    element: <CustomerPreInfo />,
  },
  {
    path: CUSTOMER_UPDATER,
    element: <CustomerUpdater />,
  },
  {
    path: FAMILY_ADDER,
    element: <FamilyAdder />,
  },
  //問診
  {
    path: MEDICAL_QUESTIONNAIRES_CUSTOMER_SELECTOR,
    element: <MedicalQuestionnairesCustomerSelector />,
  },
  {
    path: MEDICAL_QUESTIONNAIRES,
    element: <MedicalQuestionnaires />,
  },
  //処方箋申込
  {
    path: CUSTOMER_SELECTOR,
    element: <CustomerSelector />,
  },
  {
    path: IS_NEW_PHARMACY_SELECTOR,
    element: <IsNewPharmacySelectorHandler />,
  },
  {
    path: PHARMACY_LIST,
    element: <PharmacyList />,
  },
  {
    path: PHARMACY_SELECTOR,
    element: <PharmacySelector />,
  },
  {
    path: PHARMACY_INFORMATION,
    element: <PharmacyInformation />,
  },
  {
    path: SPECIFIED_COMMERCIAL,
    element: <SpecifiedCommercial />,
  },
  {
    path: PRESCRIPTION_TYPE_SELECTOR,
    element: <PrescriptionTypeSelector />,
  },
  {
    path: PRESCRIPTION_DIRECTOR,
    element: <PrescriptionDirector />,
  },
  {
    path: PRESCRIPTION_RESERVATION,
    element: <PrescriptionReservation />,
  },
  {
    path: INTERVIEW_NOT_REGISTERED,
    element: <InterviewNotRegistered />,
  },
  {
    path: RECEPTION_METHOD,
    element: <ReceptionMethod />,
  },
  {
    path: INSURANCE_INFORMATION,
    element: <InsuranceInformation />,
  },
  {
    path: PRESCRIPTION_CREATOR,
    element: <PrescriptionCreator />,
  },
  {
    path: FINISHED_PRESCRIPTION,
    element: <FinishedPrescription />,
  },
  //お会計
  {
    path: MEDICAL_ACCOUNT,
    element: <MedicalAccount />,
  },
  // 受付薬履歴
  {
    path: MEDICAL_HISTORY,
    element: <MedicalHistory />,
  },
  //受取薬明細
  {
    path: RECEIVE_MEDICATION_DETAILS,
    element: <ReceiveMedicationDetails />,
  },
  {
    path: PAYING_PAGE,
    element: <PayingPage />,
  },
  //ご利用履歴
  {
    path: PRESCRIPTION_HISTORY,
    element: <PrescriptionHistory />,
  },
  //クレジットカード決済
  {
    path: SELECT_CREDIT_CARD,
    element: <SelectCreditCard />,
  },
  //PAY決済開始
  {
    path: START_PAY,
    element: <StartPay />,
  },
  //GMO I/F呼出
  {
    path: NAVIGATE_PAY,
    element: <NavigatePay />,
  },
  //PAY決済確認中
  {
    path: CONFIRMING_PAY,
    element: <ConfirmingPay />,
  },

  // skywayオンライン面談
  {
    path: PRESCRIPTION_MEDICATION_GUIDANCE,
    element: <PrescriptionMedicationGuidance />,
  },
  // 物品譲渡用決済方法選択画面
  {
    path: PRODUCT_DELIVERY_SELECT_PAYMENT_METHOD,
    element: <ProductDeliverySelectPaymentMethod />,
  },
  // 物品譲渡用決済画面
  {
    path: PRODUCT_DELIVERY_SELECT_CREDIT_CARD,
    element: <ProductDeliverySelectCreditCard />,
  },
  // 物品譲渡用決済完了画面
  {
    path: PRODUCT_DELIVERY_COMPLETE_PAYMENT,
    element: <ProductDeliveryCompletePayment />,
  },
  // 物品譲渡エラー画面
  {
    path: PRODUCT_DELIVERY_ERROR,
    element: <ProductDeliveryError />,
  },
  // 物品譲渡Pay決済開始画面
  {
    path: PRODUCT_DELIVERY_START_PAY,
    element: <ProductDeliveryStartPay />,
  },
  // 物品譲渡PAY決済確認中画面
  {
    path: PRODUCT_DELIVERY_CONFIRMING_PAY,
    element: <ProductDeliveryConfirmingPay />,
  },
];

export default function ThemeRoutes() {
  return useRoutes(Routes);
}
